import React, { Component } from 'react';
import CN from 'classnames';
import { Icon } from 'elements';

import './NonPsychic.css';
import { Button } from 'antd';


export default class NonPsychic extends Component {

  static propTypes = {
    nonPsychic: React.PropTypes.object,
    addFreeQuestionFunction: React.PropTypes.func
  };

  state = {
    nonPsychic: this.props.nonPsychic
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  render() {
    const nonPsychic = this.props.nonPsychic;
    return (
      <div className="non-psychic-row">
        <div>
          <div className="non-psychic-info">
            <div>
              name: {nonPsychic.name}
            </div>
            <div>
              email: {nonPsychic.email}
            </div>
            <div>
              free questions: {nonPsychic.freeMessages}
            </div>
          </div>
          <Button onClick={this.props.addFreeQuestionFunction}>Add Free Question</Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/non-psychic/NonPsychic.jsx